var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.202332,
    width: 10,
    height: 8.87645,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_258_1242",
    transform: "translate(0 -0.0632884) scale(0.015625 0.0176028)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_258_1242",
    width: 64,
    height: 64,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABAEAQAAABQ8GUWAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAKqNIzIAAAAJcEhZcwAAAGAAAABgAPBrQs8AAAAHdElNRQfmCRAHDSjUlKfjAAADQElEQVR42t3bvU9TURjA4feUQoKWRYQ4mABpYXCACkYSBow2bXr5TBGsWP4DHRgMC4Nhkq2LMhogfGhLQwgUmwZM6GSQkhAoAQphMBIGoIOEoqVcpxoGQc65H+c9fUfSw8nvuYdbctMCKBz7SlmZZJmcdMYSCeevnR3pVV9fR3tentLfq9cQJYsbfFarfGduDt4WFl78ueyLRJKmxsYFcnzMO1AzgMviRUNgArCvFBcbe9fWIF1UdOUL6+fnTcvNzX5/Msk79LIxsCwyPu3p+W88AEDEZjuunp7u6MjP5x2qKoAcray89ouRIzABkMDuLtUCxAhMAOmvXq/spfy7jthsPz+EQo9kk4l39MXJYVm0Ez04sMS3tkiFywVHhmsjEn9JSe732tr7t/z+9fWzM97xAAr/D5As7e0wMDYG3txcmnWY3iIVAWQDgmIA0RFUARAZQTUAURFUBRARQXUA0RA0ARAJQTMAURA0BRABQXMA7Ai6APxFaBgfh7jRiAlBNwCsCLoCYETQHQAbAhcATAjcALAgcAXAgMAdgDcCCgCeCExPhbWYz9sTE+TM44Fyuoel5Fl9/Q13IPBGvv7D2YvD9FRYq4l/i8UqajY3oYjuaTP8Npt/PNjf3363tES7J5oTkJnZAZ8PZjs7aU8C3G1qYtkPHQAAALzMoT+Zy+l0VgA4n3d1wfvRUdqbIXyZmWHZD827QCaeLA0OQjnlCfAHgw9vtrT0kfNz2j3R3AQlr9tNUsPDAJRXviAcPnnR1jZEUimWfVGcAMnrdsPuyAj1sS8Ih08+tbYukNNT1r25A/CM5w7AO54rAIZ4bgBY4rkAYIrXHQBbvK4AGON1A8AarwsA5njNAbDHawogQrxmAKLEawIgUrzqAKLFqwogYrxqAKLGqwIgcrxiANHjFQFIFo8HYGiI9gGm/DoUSj5xuTDEMwM4lquqDNbFRdJI+f1ARFc+M3RHN7PocXe3XEcXj+3KZ4btS1MfS0uzIZ4ZAA5XV7Mhnhkg5ezvh3tHR6LHMwPM3d7bM2w4HFciFITD2OOZAQAAgsFo9LzObv8nAsK7vWYjWcxmKTI15YwlEtJIPO7c6O2tqab7TDDP+QPwiKnQDlvUCQAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAyMi0wOS0xNlQwNzoxMzo0MCswMDowMPs4/GkAAAAldEVYdGRhdGU6bW9kaWZ5ADIwMjItMDktMTZUMDc6MTM6NDArMDA6MDCKZUTVAAAAKHRFWHRkYXRlOnRpbWVzdGFtcAAyMDIyLTA5LTE2VDA3OjEzOjQwKzAwOjAw3XBlCgAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right_arrow.900a7aee62b1b323a2caf994dd7cfb89.svg";
export { ForwardRef as ReactComponent };